"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-DistanceInput',
    label: 'c-DistanceInput__label'
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        'align-items': 'center'
    }
};
//# sourceMappingURL=distance.input.style.js.map